import React from 'react';
import Header from "./components/header";
import ReactGA from 'react-ga';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useHistory
} from "react-router-dom";
import Person from './components/person';
import Home from "./components/home";


function App() {

    ReactGA.initialize('UA-16336374-1');
    ReactGA.pageview(window.location.pathname + window.location.search);


  let history = useHistory();

  return (
    <>
    <Router>
        <Route exact path="/40under40_2020">
            <Home />
        </Route>
        <Route path="/40under40_2020/:id" >
            <Person />
        </Route>
    </Router>
    </>
  );
}

export default App;
